import React, { useState } from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";

const DefaultCoordinate = {
  lat: 23.16611,
  lng: 75.80956,
};

const containerStyle = {
  width: "100%",
  height: "500px",
  borderRadius: "12px",
};

export default function UserInitiatedLocation() {
  const [coords, setCoords] = useState(null);
  const [error, setError] = useState(null);
  const [isAsking, setIsAsking] = useState(false);

  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-api",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
  });

  // Triggered ONLY when the user clicks the "Enable Location" button
  const requestLocation = () => {
    if (!("geolocation" in navigator)) {
      setError("Geolocation is not supported by your browser.");
      return;
    }

    setIsAsking(true);
    setError(null);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setCoords({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        setIsAsking(false);
      },
      (err) => {
        setIsAsking(false);
        if (err.code === err.PERMISSION_DENIED) {
          setError(
            "Permission denied. Please allow location access in your browser settings to see the map.",
          );
        } else {
          setError("Location request timed out or failed. Please try again.");
        }
      },
      { timeout: 10000, enableHighAccuracy: true },
    );
  };

  if (loadError) return <div>Error loading maps API</div>;
  if (!isLoaded) return <div>Loading Google Maps resources...</div>;

  const mapCenter = coords || DefaultCoordinate;

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      {!coords ? (
        <div
          style={{
            background: "#f0f4f8",
            padding: "24px",
            borderRadius: "8px",
            maxWidth: "500px",
            margin: "0 auto",
          }}
        >
          <h4 className="text-black" style={{ marginBottom: "16px" }}>
            We need your location to show nearby places
          </h4>

          <button
            onClick={requestLocation}
            disabled={isAsking}
            style={{ padding: "10px 20px", cursor: "pointer" }}
            className="btn btn-secondary"
          >
            <span>
              {isAsking ? "Waiting for browser approval..." : "Enable Location"}
            </span>
          </button>

          {error && <p style={{ color: "red", marginTop: "12px" }}>{error}</p>}
        </div>
      ) : (
        <div>
          <h4>Location Acquired!</h4>
          <p style={{ marginBottom: "16px" }}>
            Lat: {coords.lat}, Lng: {coords.lng}
          </p>

          <GoogleMap
            mapContainerStyle={containerStyle}
            center={mapCenter}
            zoom={15}
          >
            <Marker position={coords} title="You are here!" />
          </GoogleMap>
        </div>
      )}
    </div>
  );
}
